import React, { useContext } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import classNames from "classnames";
import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import { hasActiveEvents } from "@utils/my-bets/helpers";

export default observer(function ReuseButton() {
	const { t } = useTranslation("mybets");
	const bet = useContext(MyBetsBetContext);

	const store = useContext(MyBetsStoreContext);

	if (store == null) {
		console.error("Expected store, got null.");
		return null;
	}

	const {
		reuseBetSlipStore: { openReuseBetSlipModal },
	} = store;

	if (!hasActiveEvents(bet)) {
		return null;
	}

	const reuseClasses = classNames(
		"card--bet__btn card--bet__btn--reuse",
		"btn btn--sml btn--primary--subtle btn--icon btn--animate-rotate no-print"
	);

	return (
		<button
			type="button"
			className={reuseClasses}
			onClick={() => openReuseBetSlipModal(bet)}
		>
			<i className="u-icon u-icon--sml u-icon--refresh" />

			<span>{t<string>("REUSE.BUTTON_LABEL")}</span>
		</button>
	);
});
